import { cn } from "@newxsystems/shared";
import { getComponent } from "../../../../client";
import type { IEffectfulHeroActionProps } from "./EffectfulHeroAction.props";

const styles = {
  onDark: {
    primary:
      "border-primary bg-primary text-primary-foreground hover:border-signal-dim hover:bg-signal-dim",
    secondary:
      "border-border bg-transparent text-foreground hover:border-primary hover:bg-primary/10 hover:text-primary",
    ghost:
      "border-transparent bg-transparent px-0 text-primary underline decoration-primary/40 underline-offset-4 hover:decoration-primary",
    destructive:
      "border-destructive bg-destructive text-background hover:border-foreground hover:bg-foreground hover:text-background",
  },
  onAccent: {
    primary:
      "border-primary-foreground bg-primary-foreground text-primary hover:border-background hover:bg-background",
    secondary:
      "border-primary-foreground/40 bg-transparent text-primary-foreground hover:border-primary-foreground hover:bg-primary-foreground/10",
    ghost:
      "border-transparent bg-transparent px-0 text-primary-foreground underline decoration-primary-foreground/40 underline-offset-4 hover:decoration-primary-foreground",
    destructive:
      "border-destructive bg-destructive text-background hover:border-foreground hover:bg-foreground hover:text-background",
  },
} as const;

export const EffectfulHeroAction = ({
  action,
  className,
  tone = "onDark",
}: IEffectfulHeroActionProps) => {
  const Link = getComponent("Link");
  return (
    <Link
      aria-label={action.accessibilityLabel || undefined}
      className={cn(
        "group inline-flex min-h-11 items-center justify-center gap-2.5 rounded-[8px] border px-5 py-3 font-daylight-mono text-[0.6875rem] font-medium uppercase leading-none tracking-[0.12em] transition-[background-color,border-color,color,text-decoration-color] duration-200 ease-out focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring",
        styles[tone][action.style || "primary"],
        className,
      )}
      href={action.href}
      rel={action.openInNewTab ? "noopener noreferrer" : undefined}
      target={action.openInNewTab ? "_blank" : undefined}
    >
      <span>{action.label}</span>
      <span
        aria-hidden="true"
        className="font-daylight-body text-sm leading-none transition-transform duration-200 ease-out group-hover:translate-x-1"
      >
        →
      </span>
    </Link>
  );
};

EffectfulHeroAction.displayName = "EffectfulHeroBlock::EffectfulHeroAction";
